module.exports = __webpack_public_path__ + "static/portfolio-mas-3-1c2d0d3047b211fc48b393ac9ac34a60.jpg";